<template>
  <div class="page list-archivbestaende">
    <v-container grid-list-sm>
      <v-layout row wrap>
        <v-flex sm12 class="sec_col flex-grow-1 flex-shrink-0">
          <div class="col-inner col-highlight">
            <h1>Archivbestände</h1>
            <Archivbestand v-if="authorized" :lang="lang"></Archivbestand>
            <div v-else>
              <p>Bitte geben Sie das Passwort ein, um die Archivbestände zu sehen.</p>
              <v-text-field v-model="pwd" label="Passwort" type="password" color="secondary"></v-text-field>
              <v-btn @click="authorized = stringToHash(pwd) === 164812873">Einloggen</v-btn>
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Archivbestand from '@/components/pages/partials/Archivbestand.vue'
export default {
  data () {
    return {
      pwd: '',
      authorized: false
    }
  },
  components: {
    Archivbestand
  },
  methods: {
    stringToHash (string) {
      var hash = 0
      if (string.length === 0) return hash
      for (var i = 0; i < string.length; i++) {
        var char = string.charCodeAt(i)
        hash = ((hash << 5) - hash) + char
        hash = hash & hash
      }
      return hash
    }
  },
  computed: {
    ...mapGetters([
      'lang'
    ])
  }
}
</script>
<style lang="scss">
.list-archivbestaende {

  .v-btn {
    margin: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Archivbestaende.vue